<!-- TODO refactor this component to remove external page logic from it -->
<template>
  <div class="al-contextual-menu" test-id="al-contextual-menu">
    <div v-if="page" :id="mainId" class="al-contextual-menu-button">
      <span tabindex="-1">...</span>
    </div>
    <div
      v-else
      :id="mainId"
      class="al-contextual-menu-button"
      :class="[{ 'is-active': show }]"
      :data-show="show"
      @click.prevent.stop="show != show"
    >
      <slot name="button">
        <al-icon icon="menu" />
      </slot>
    </div>

    <b-popover
      :placement="placement"
      :custom-class="`al-contextual-menu-body ${position}`"
      :show.sync="show"
      :target="mainId"
    >
      <div v-click-outside="closeContextualMenu" class="al-contextual-menu-wrapper">
        <slot />
      </div>
    </b-popover>
  </div>
</template>

<script>
import Vue from 'vue';
import { BPopover } from 'bootstrap-vue';
import AlIcon from '../inline/icon/AlIcon.vue';
/**
 * Playvox button with a past definition
 *
 * @displayName al-button
 */
export default {
  name: 'AlContextualMenu',
  // -------------------------------------------------
  // + Life Cicle
  // -------------------------------------------------
  components: {
    AlIcon,
    // eslint-disable-next-line vue/no-unused-components
    BPopover
  },
  props: {
    /**
     * Element Identify
     */
    id: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'top-right'
    },
    page: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    mainId() {
      // eslint-disable-next-line no-underscore-dangle
      const id = this.id || this._uid;
      return `contextual-menu-${id}`;
    },
    placement() {
      if (this.position === 'center-left') {
        return this.convertPosition('left');
      }
      return this.convertPosition(this.position);
    }
  },
  methods: {
    click(e) {
      if (!this.page) {
        e.preventDefault();
        this.show = !this.show;
      }
    },
    convertPosition(position) {
      return position.replace('-', '');
    },
    closeContextualMenu() {
      this.show = false;
    }
  }
};

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    const vm = vnode.context;
    const callback = binding.value;

    // eslint-disable-next-line no-param-reassign
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        return callback.call(vm, event);
      }
      return null;
    };

    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});
</script>

<style lang="scss">
/**
* Variables
*/
$br-radius: 4px;
$w-button: 24px;
$h-button: 24px;
$color-button: #04100f;
$bg-button-hover: #dff7ef;

$w-content: 224px;
$p-content: 12px 0;
$ml-content: -6px + 24px - 4px;
$mr-content: -6px + 24px - 4px;
$mt-content: -2px - 4px;
$mb-content: -2px - 4px;

$box-shadow: 0 12px 8px -4px rgba(54, 64, 63, 0.1);

.al-contextual-menu {
  padding: 0;

  .al-contextual-menu-button {
    align-items: center;
    background-color: transparent;

    border-radius: $br-radius;
    color: $color-button;

    display: flex;
    height: $h-button;
    justify-content: center;
    transition: 0.3s;
    width: $w-button;

    &.is-active,
    &:hover {
      background-color: $bg-button-hover;
      cursor: pointer;
    }
  }
}

.al-contextual-menu-body {
  background-color: #fff;
  border: 1px solid #d9e3e2;
  border-radius: $br-radius;
  box-shadow: $box-shadow;
  padding: $p-content;

  &.top-right {
    margin-bottom: $mb-content;
    margin-left: $ml-content;
  }

  &.bottom-right {
    margin-left: $ml-content;
    margin-top: $mt-content;
  }

  &.center-right {
    margin-left: -4px;
  }

  &.top-left {
    margin-bottom: $mb-content;
    margin-right: $mr-content;
  }

  &.bottom-left {
    margin-right: $mr-content;
    margin-top: $mt-content;
  }

  &.center-left {
    margin-right: -4px;
  }

  .popover-body {
    padding: 0;
  }

  .arrow {
    display: none;
  }
}
</style>
